function visibleTransportationProfiles (profiles, excludeProfileId) {
  const list = Array.isArray(profiles) ? profiles : []
  if (!excludeProfileId) return list
  return list.filter(function (profile) {
    return !profile || profile.id !== excludeProfileId
  })
}

function selectionMatchesExcluded (profile, excludeProfileId) {
  if (!excludeProfileId || !profile || !profile.id) return false
  return profile.id === excludeProfileId
}

module.exports = {
  visibleTransportationProfiles: visibleTransportationProfiles,
  selectionMatchesExcluded: selectionMatchesExcluded
}
